import { GlobalRights, HistoryItem } from '@reporting/rp-types/core';
import rp, { MarkdownEditor, MarkdownEditorAdapter, MarkdownEditorOptions } from "@reporting/rp-app-host";
import { Thread } from "@reporting/rp-types/deployment";

export class DocEditorAdapter extends MarkdownEditorAdapter<MarkdownEditor> {

	constructor(
		private thread: Thread,
	) { super() }

	async save(content: string) {
		await rp.ms('deployment').patch(`threads/${this.thread.id_thread}/doc`, content, { accounting: this.thread.accounting });
	}

	async getContent(): Promise<string> {
		return await rp.ms('deployment').get<string>(`threads/${this.thread.id_thread}/doc`);
	}

	async getHistoryContent(idz: number): Promise<string> {
		return rp.ms('deployment').get<string>(`threads/${this.thread.id_thread}/docHistory/${idz}`);
	}

	getHistoryItems(): Promise<HistoryItem[]> {
		return rp.ms('deployment').get<HistoryItem[]>(`threads/${this.thread.id_thread}/history`);
	}

	getOptions(): MarkdownEditorOptions {
		const isReadonly = rp.userProvider.hasRight(GlobalRights.DeploymentRead) && !rp.userProvider.hasRight(GlobalRights.Deployment);
		// TODO: disable file upload
		return this.createOptions({
			readOnly: isReadonly,
			history: true,
			disableImgUpload: true,
		});
	}

	getCurrentItem(): HistoryItem {
		return this.thread;
	}

}
